import * as React from 'react';

import { FavoriteButtonDesktop } from '../../components/FavoriteButton';
import { useFavoriteButton } from './hooks/useFavoriteButton';

export const FavoriteButtonDesktopContainer: React.FC = () => {
  const { isFavorite, handleClickFavorite } = useFavoriteButton();

  return <FavoriteButtonDesktop isFavorite={isFavorite} onClick={handleClickFavorite} />;
};
